import { routes, LAYOUT } from '../../utils/constants/help.routes';
import { renderRoutes } from '../../utils/router.utils';

const homePath = null;

const HelpManager = () => renderRoutes(Object.values(routes), LAYOUT, homePath);

export default HelpManager;
